import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import moment from "moment"
import { v4 as uuid } from "uuid";
import _ from "lodash";

import { Dialog } from 'primereact/dialog';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tooltip } from "primereact/tooltip";
import { Sidebar } from "primereact/sidebar";

import { CheckboxField, Table } from "../../helpers";
import Button from "../../helpers/Button";
import Menu from "../../helpers/Menu";

import ButtonGroup from "../../common/ButtonGroup";
import PMUserName from "../../common/PMUserName";
import Loading from "../../common/Loading";
import CopyToClipboard from "../../common/CopyToClipboard";
import Description from "../../common/Description";
import FileViewAndRemove from "../../common/FileViewAndRemove";
import FileViewModal from "../../common/FileViewModal";

import Search from "./Components/Search";
import RequestPettyCash from "./Components/RequestPettyCashModal";
import AddExpense from "./Components/AddExpense";
import PendingRequest from "./Components/pendingRequest"
import SecondayPaymentStatus from "./Components/SecondayPaymentStatus";
import RaiseTicketModal from "./Components/RaiseTicketModal";
import EditPettyCash from "./Components/EditPettyCash";

import { getPettyCashUsers } from "../../services/api/pettyCashUsers";
import { cancelPettyCash, getPendingPettyCash, updatePettyCashBookingStatus } from "../../services/api/pettyCash";
import { fetchPettyCashCategories, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { fetchPettyCash, updateSearchParams, setIsSearchVisible } from "../../services/redux/reducers/pettycash/pettycash";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { getPettyCashDailyBalanceByPettyCashAccountId, getPettyCashDailyOpeningAndClosingBalances } from "../../services/api/pettyCashDailyBalances";
import { getPettyCashAccounts } from "../../services/api/pettyCashAccounts";
import { getPettyCashAccountByUserId } from "../../services/api/pettyCashAccounts";

import "./index.css"

import RaiseImg from "../../images/click.jpg"
import greyClockImg from "../../images/greyClock.png"
import checkInCircleImg from "../../images/check-circle.png"
import WorkInProgressImg from "../../images/work-in-progress.png";
import EditImg from "../../images/Edit.webp"

import { checkPermissions, getDateString, getFullName, isMobile, numberConversion, round, sortArrayOfObjectsInAlphabeticalOrder } from "../../utils";
import { pettyCashTransactionDetails } from "../../validation/pettyCashValidation";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../../constants";
import { useSearchPin } from "../../hooks/useSearchPin";


const initialProduct = {
	id: uuid(),
	pettyCashCategoryId: "",
	prodDesc: "",
	unit: 0,
	HSNCode: 0,
	TDS: 0,
	unitPrice: 0,
	quantity: 0,
	CGST: 0,
	SGST: 0,
	IGST: 0,
	disabled : true,
    isDocNoMandatory: false
}


const PettyCash = () => {
    const dispatch = useDispatch()
    const { isSearchPinned, toggleSearchPin, setSearchPin } = useSearchPin()
    
    const [visiblePettyCashRequest, setVisiblePettyCashRequest] = useState(false)
    const [visibleAddExpense, setVisibleAddExpense] = useState(false)
    const [visiblePendingRequest, setVisiblePendingRequest] = useState(false)
    const [visiblePettyCashDocs, setVisiblePettyCashDocs] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [pettyCashAccount, setUserPettyCashAccount] = useState({})
    const [pettyCashAccountsDetails, setPettyCashAccountsDetails] = useState([])
    const [pettyCashUsers, setPettyCashUsers] = useState([])
    const [pettyCashBalance, setPettyCashBalance] = useState({})
    const [pendingPettyCash, setPendingPettyCash] = useState([])
    const [selectedPettyCash, setSelectedPettyCash] = useState([])
    const [selectedPettyCashDoc, setSelectedPettyCashDoc] = useState([])
    const [openingBalance, setOpeningBalance] = useState("")
    const [closingBalance, setClosingBalance] = useState("")
    const [selectedPettyCashId, setSelectedPettyCashId] = useState(null)
    const [isRaiseTicketVisible, setIsRaiseTicketVisible] = useState(false)
    const [selectedRow, setSelectedRow] = useState({})
    const [isEditPettyCashVisible, setIsEditPettyCashVisible] = useState(false)
    const [isHoveringSearchZone, setIsHoveringSearchZone] = useState(false)
    const [hasEverHoveredRightEdge, setHasEverHoveredRightEdge] = useState(false)

    //Add Expense
    const [productsList, setProductsList] = useState([initialProduct])
    const [transactionDetails, setTransactionDetails] = useState(pettyCashTransactionDetails)

    const [visibleDocViewer, setVisibleDocViewer] = useState(false)

    const actionMenu = useRef(null)

    const op = useRef(null)

    const usersData = useSelector(state => state.userDetails)
    const statusList = useSelector((state) => state.common.status)
    const pettyCashData = useSelector(state => state.pettyCash.pettyCashData)
    const pettyCashItemsData = useSelector(state => state.pettyCash.pettyCashItemsData)
    const bookingLogs = useSelector(state => state.pettyCash.bookingLogs)
    const ticketsData = useSelector(state => state.pettyCash.ticketsData)
    const isTableLoading = useSelector(state => state.pettyCash.loading)
    const paginationParams = useSelector(state => state.pettyCash.paginationParams)
    const searchParams = useSelector(state => state.pettyCash.searchParams)
    const isSearchVisible = useSelector(state => state.pettyCash.isSearchVisible)
    const isSearchActive = useSelector(state => state.pettyCash.isSearchActive)

    const pettyCashCategories = useSelector(state => state.common.pettycashCategories)
    const companyUsers = usersData?.PMCompanyDetails.companyUsers

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const location = useLocation()

    const isMobileDevice = isMobile()

    const handleDocViewOnHide = () => {
        setVisibleDocViewer(false)
    }
    
    useEffect(()=> {
        const queryParams = new URLSearchParams(location.search)

        if (queryParams.get('docNo')){
            dispatch(fetchPettyCash({ ...paginationParams, ...searchParams, searchBy : 'Transaction No', searchText:  queryParams.get('transactionNo'), onlyMe: false, docNo: queryParams.get('docNo')}))
        }
        else if (queryParams.get('vendorPaymentNo')){
            dispatch(fetchPettyCash({ ...paginationParams, ...searchParams, searchBy : 'vendorPaymentNo', searchText:  queryParams.get('vendorPaymentNo'), onlyMe: false, vendorPaymentNo: queryParams.get('vendorPaymentNo')}))
        }
        else if (queryParams.get('voucherNo')){
            dispatch(fetchPettyCash({ ...paginationParams, ...searchParams, searchBy : 'voucherNo', searchText:  queryParams.get('voucherNo'), onlyMe: false, voucherNo: queryParams.get('voucherNo')}))
        }
        else if (queryParams.get('pettyCashId')){
            dispatch(fetchPettyCash({ ...paginationParams, ...searchParams, searchBy : 'pettyCashId', searchText:  queryParams.get('pettyCashId'), onlyMe: false, pettyCashId: queryParams.get('pettyCashId')}))
        }
        else{
            getPettyCashData()
        }

        getPettyCashAccountsDetails()
    }, [usersData])

    useEffect(() => {
        if (!isSearchPinned && !isHoveringSearchZone) {
            dispatch(setIsSearchVisible(false))
          }

        const handleMouseMove = (e) => {
            if (isSearchPinned) return

            const panelWidth = window.innerWidth * 0.18
            const buffer = 8
            const screenRightEdge = window.innerWidth
            const activeZoneLeft = screenRightEdge - (panelWidth + buffer)

            if (e.clientX < activeZoneLeft) {
                setIsHoveringSearchZone(false)
                setHasEverHoveredRightEdge(false)
            } else {
                setIsHoveringSearchZone(true)
            }
        }

        if (!isSearchPinned && (isHoveringSearchZone || hasEverHoveredRightEdge)) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [isSearchPinned, isHoveringSearchZone, hasEverHoveredRightEdge])

    useEffect(() => {
        dispatch(fetchStatus())
        dispatch(fetchPettyCashCategories())
    }, [pettyCashData, searchParams])

    useEffect(() => {
        getPettyCashUsersDetails()
    }, [searchParams])

    // useEffect(() => {
    //     if (searchParams?.fromDate){
    //         getOpeningAndClosingBalances()
    //     }
    // }, [searchParams, pettyCashAccount])

    const getPettyCashData = async () => {
        let relatedAccount
        if (usersData?.userId){
            relatedAccount = await getPettyCashAccountByUserId(usersData.userId)
            const relatedPendingPettyCash = await getPendingPettyCash(usersData?.userId)

            if (relatedPendingPettyCash?.failure){
                dispatch(raiseToast({severity:'error', summary: relatedPendingPettyCash.data.error, detail:'Petty Cash Balance is Not Fetched', life: 3000}))
            }else{
                if (relatedAccount.data[0]?.pettyCashAccountId){
                    const pettyCashBalanceRes = await getPettyCashDailyBalanceByPettyCashAccountId(relatedAccount.data[0].pettyCashAccountId)
                    setPettyCashBalance(pettyCashBalanceRes)
                }
            }
            if (relatedAccount?.failure){
                dispatch(raiseToast({severity:'error', summary: relatedAccount.data.error, detail:'User Petty Cash Account is Not Fetched', life: 3000}))
            }else{
                setUserPettyCashAccount(relatedAccount.data[0])
            }
            setPendingPettyCash(relatedPendingPettyCash)
        }

        const fromDate = new Date(new Date().setMonth(new Date().getMonth() - 1, 1)) // 1st of previous month at initial load
        const toDate = new Date()

        fromDate.setHours(0, 0, 0, 0)
        toDate.setHours(23, 59, 0, 0)
        
        let updatePettyCashAccount = relatedAccount.data[0]?.pettyCashAccountId

        const {isPermitted: isPermittedToViewAllPettyCashes} = checkPermissions({...usersData, permissions: [200]}) 
        if (!searchParams.onlyMe && isPermittedToViewAllPettyCashes){
            updatePettyCashAccount = null
        }
        const isUserPrimaryHolder = relatedAccount.data[0]?.primaryHolder === usersData.userId
        
        let updatedParams = {
            ...paginationParams,
            ...searchParams,
            pettyCashAccount: updatePettyCashAccount,
            onlyMe: true,
            fromDate : fromDate,
            toDate : toDate,
            isUserPrimaryHolder: isUserPrimaryHolder
        }
        
        dispatch(updateSearchParams(updatedParams))
        if(relatedAccount.data[0]?.pettyCashAccountId){
            dispatch(fetchPettyCash(updatedParams))
        }

        getOpeningAndClosingBalances(updatePettyCashAccount, fromDate, toDate)
    }

    const getPettyCashUsersDetails = async () => {
        const pettyCashUsersRes = await getPettyCashUsers()
        // console.log("pettyCashUsersRes", pettyCashUsersRes)
        if (pettyCashUsersRes?.failure){
            dispatch(raiseToast({severity:'error', summary: pettyCashUsersRes.data.error, detail:'Petty Cash Users are Not Fetched', life: 3000}))
        }else{
            const updatedPettyCashUsers = pettyCashUsersRes?.data?.map(eachUser => ({...eachUser, name: getFullName(eachUser?.users?.firstName, eachUser?.users?.lastName)}))
            setPettyCashUsers(updatedPettyCashUsers)
        }
    }

    const getPettyCashAccountsDetails = async () => {
        const pettyCashAccountsRes = await getPettyCashAccounts({paginator: false})
        if (pettyCashAccountsRes?.failure){
            dispatch(raiseToast({severity:'error', summary: pettyCashAccountsRes.data.error, detail:'Petty Cash Accounts are Not Fetched', life: 3000}))
        }else{
            const sortedPettyCashAccountDetails = sortArrayOfObjectsInAlphabeticalOrder(pettyCashAccountsRes.data, "pettyCashAccount")
            setPettyCashAccountsDetails(sortedPettyCashAccountDetails)
        }
    }

    const getOpeningAndClosingBalances = async (PettyCashAccountId, defaultFromDate, defaultToDate) => {
        let closingDate = searchParams?.toDate ? searchParams?.toDate : (defaultToDate ? defaultToDate : new Date())
        let openingDate = Date.parse(searchParams?.fromDate) <= Date.parse(new Date("02-04-2024")) ? new Date("2024-02-04") : searchParams?.fromDate
        if (!searchParams?.fromDate){
            if(defaultFromDate){
                openingDate = defaultFromDate
            }
            else{
                openingDate = new Date()
                let date = openingDate.getDate()
                openingDate.setDate(date - 1)
            }
            
        }

        let data = {
            openingDate: moment(openingDate).format("YYYY-MM-DD"),
            closingDate: moment(closingDate).format("YYYY-MM-DD")
        }

        if (searchParams?.onlyMe || searchParams?.account || pettyCashAccount?.pettyCashAccountId){
            let pettyCashAccountId = searchParams?.account ? searchParams?.account : ( PettyCashAccountId ? PettyCashAccountId : pettyCashAccount.pettyCashAccountId )
            const openingClosingBalanceRes = await getPettyCashDailyOpeningAndClosingBalances(pettyCashAccountId, data)
            //console.log("openingClosingBalanceRes", openingClosingBalanceRes)
            if (openingClosingBalanceRes?.failure){
                dispatch(raiseToast({severity:'error', summary: openingClosingBalanceRes.data.error, detail:'Petty Cash Balances are Not Fetched', life: 3000}))
                setOpeningBalance(null)
                setClosingBalance(null)
            }else{
                let fromDate = Date.parse(searchParams?.fromDate) <= Date.parse(new Date("02-04-2024")) ? new Date("2024-02-04") : searchParams?.fromDate
                let newFromDate = new Date(fromDate)
                let date = newFromDate.getDate()
                newFromDate.setDate(date - 1)
                if (searchParams?.fromDate){
                    const openingBalance = openingClosingBalanceRes?.find(eachBalance => moment(eachBalance.balanceDate).format("YYYY-MM-DD") === moment(newFromDate).format("YYYY-MM-DD"))
                    const closingBalance = openingClosingBalanceRes?.find(eachBalance => moment(eachBalance.balanceDate).format("YYYY-MM-DD") === moment(searchParams?.toDate).format("YYYY-MM-DD"))
                    
                    setOpeningBalance(openingBalance?.approvedBalance ? openingBalance?.approvedBalance : 'NA')
                    setClosingBalance(closingBalance?.approvedBalance ? closingBalance?.approvedBalance : 'NA')
                }
                else if(defaultFromDate){
                    let prevFromDate = new Date(defaultFromDate)
                    let date = prevFromDate.getDate()
                    prevFromDate = prevFromDate.setDate(date - 1)
                    const openingBalance = openingClosingBalanceRes?.find(eachBalance => moment(eachBalance.balanceDate).format("YYYY-MM-DD") === moment(prevFromDate).format("YYYY-MM-DD"))
                    const closingBalance = openingClosingBalanceRes?.find(eachBalance => moment(eachBalance.balanceDate).format("YYYY-MM-DD") === moment(defaultToDate).format("YYYY-MM-DD"))

                    setOpeningBalance(openingBalance?.approvedBalance ? openingBalance?.approvedBalance : 'NA')
                    setClosingBalance(closingBalance?.approvedBalance ? closingBalance?.approvedBalance : 'NA')
                    
                }
                else if (searchParams?.account){
                    setOpeningBalance(openingClosingBalanceRes[0]?.approvedBalance)
                    setClosingBalance(openingClosingBalanceRes[0]?.approvedBalance)
                }else{
                    setOpeningBalance(null)
                    setClosingBalance(null)
                }
                // setPettyCashAccountsDetails(openingClosingBalanceRes?.data)
            }
        }else{
            setOpeningBalance(null)
            setClosingBalance(null)
        }
    }


    const getHeaderCheckbox = ()=>{
        return(
            <div className=""> <CheckboxField onChange={(e) => handleSelectClick(e)} checked={pettyCashData?.length && pettyCashData?.length === selectedPettyCash?.length}/></div>
        )
    }

    const getBodyCheckbox = (row)=>{
        const relatedPettyCash = selectedPettyCash?.find(eachPettyCash => eachPettyCash?.pettyCashId === row?.pettyCashId)
        return(
            <div className="">
                <CheckboxField onChange={() => handleCheckboxClick(row)} checked={relatedPettyCash ? true : false}/>
            </div>
        )
    }

    const getAmountBody = (row) => {
        if(row.entryType === "REQUEST"){
            return <div className="increment-btn-icon">{`+ ${numberConversion(row.amount, numberLocale)}`}</div>
        }else{
            return <div className="decrement-btn-icon">{`- ${numberConversion(row.amount, numberLocale)}`}</div>
        }
    }

    const getNatureOfExpenseBody = (row) => {
        const pettyCashId = row.pettyCashId
        let natureOfExpenseStrList = []
        let pettyCashItemCategoryIds = []
        pettyCashItemsData?.filter((eachPettyCashItem) => {
            if(eachPettyCashItem.pettyCashId === pettyCashId){
                pettyCashItemCategoryIds.push(eachPettyCashItem.pettyCashCategoryId)
            }
        })

        if(pettyCashItemCategoryIds.length > 0){
            pettyCashItemCategoryIds?.map((eachCategoryId) => {
                const pettyCashCategoryResult =  pettyCashCategories?.find(eachCategory => eachCategory.pettyCashCategoryId === eachCategoryId)
                return natureOfExpenseStrList.push(pettyCashCategoryResult?.pettyCashCategoryName)
            })
            return natureOfExpenseStrList.join(", ")
        }
        return "-"
    }

    const getDescriptionBody = (row) => {
        const relatedPettyCashItems = pettyCashItemsData?.filter(eachPettyCashItem => eachPettyCashItem?.pettyCashId === row?.pettyCashId)
        let descriptionArr = []
        relatedPettyCashItems?.map(eachPettyCashItem => descriptionArr.push(eachPettyCashItem?.prodDesc))
        let descriptionStr = descriptionArr.join(", ")
        return (
            <>
                {row?.entryType === "REQUEST" ? <div>-</div> : <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><Description text={descriptionStr} maxLength={100} /></div>}
            </>
        )
    }

    const onDeleteClick = async (row) => {
        if (row.entryType === "REQUEST"){
            return dispatch(raiseToast({severity:'error', detail:`Petty Cash Request Can't be Deleted.`, life: 3000}))
        }
        if (row["docTracker.bookedStatus"] === true){
            return dispatch(raiseToast({severity:'error', detail:`Petty Cash Can't be Deleted as it has already Booked.`, life: 3000}))
        }

        if (window.confirm("Are you sure you want to delete the PettyCash...?")){
            setIsLoading(true)
            let updatedItem = {...row, statusId : 6}
            const response = await cancelPettyCash(updatedItem.pettyCashId)
            setIsLoading(false)
            if (response?.failure){  // ? mark required as backend api returning nothting after cancel
                return dispatch(raiseToast({severity:'error', summary: response.data.error, detail:'Petty Cash is Not Deleted', life: 3000}))
            }
            setIsEditPettyCashVisible(false)
            getPettyCashData()
            dispatch(raiseToast({severity:'success', detail:'Petty Cash is Deleted', life: 3000}))
        }
    }

    const handleCheckboxClick = (row) => {
        const relatedPettyCash = selectedPettyCash?.find(eachPettyCash => eachPettyCash.pettyCashId === row?.pettyCashId)
        if (relatedPettyCash){
            const relatedPettyCashes = selectedPettyCash?.filter(eachPettyCash => eachPettyCash?.pettyCashId !== relatedPettyCash?.pettyCashId)
            setSelectedPettyCash(relatedPettyCashes)
        }else {
            const relatedPettyCashes = [...selectedPettyCash, row]
            setSelectedPettyCash(relatedPettyCashes)
        }
    }

    const handleSelectClick = (e) => {
        const relatedPettyCash = pettyCashData?.map(eachPettyCash => eachPettyCash)
        if (e.checked){
            setSelectedPettyCash(relatedPettyCash)
        }else{
            setSelectedPettyCash([])
        }
    }

    const handlePageChange = async (e) => {
        let updatePettyCashAccount = pettyCashAccount?.pettyCashAccountId
        const {isPermitted: isPermittedToViewAllPettyCashes} = checkPermissions({...usersData, permissions: [200]}) 
        if (!searchParams.onlyMe && isPermittedToViewAllPettyCashes){
            updatePettyCashAccount = null
        }
        let pettycashParams = { 
            ...searchParams,
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            pettyCashAccount: updatePettyCashAccount
        }
        if (pettycashParams.searchBy !== "all") {
            pettycashParams[pettycashParams.searchBy] = pettycashParams.searchText.trim()
        }
        dispatch(fetchPettyCash(pettycashParams))
    }

    const handleSearchTabDisplay = () => {
        if (!isSearchPinned) {
          dispatch(setIsSearchVisible(!isSearchVisible))
        }
    }
    
    const getTxnNoBody = (row) => {
        const date = moment(row?.createdAt).format(DATE_TIME_FORMAT)
        return(
            <div className='req-no-container ml-1' style={{position: "relative"}}>
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row?.docNo ? 
                        <>
                            <p className='doc-no'>{row.docNo}</p>
                            <CopyToClipboard text={row.docNo} />
                        </>
                        : ""
                    }
                </div>
                <p className='mr-4 date'>{date}</p>
            </div>
        )
    }

    const handleEditPettyCash = (row) => {
        setSelectedRow(row)
        setIsEditPettyCashVisible(true)
    }

    const editPettyCash = (row) => {
        const relatedPrimaryPettyCashAccount = pettyCashAccountsDetails.find(eachPettyCashAccount => eachPettyCashAccount.pettyCashAccountsId === row.pettyCashAccount)
        const relatedBookingLogs = bookingLogs.filter(eachBookingLog => eachBookingLog.docNo === row.docNo)
        const latestBookingLog = _.maxBy(relatedBookingLogs, "bookingLogId")

        const isPrimaryHolderOrCreator = relatedPrimaryPettyCashAccount.userId === usersData.userId ||  row.createdBy === usersData.userId
        const isBooked = Boolean(latestBookingLog?.bookedBy)
        const isEntryTypeRequest = row.entryType === "REQUEST"

        const canEdit = isPrimaryHolderOrCreator && !isBooked && !isEntryTypeRequest

        let tooltipMessage = ''
        if (!isPrimaryHolderOrCreator) {
            tooltipMessage = 'Only the primary holder or creator can edit.'
        } else if (isBooked) {
            tooltipMessage = "Can't edit booked petty cash."
        } else if(isEntryTypeRequest){
            tooltipMessage = "Editing is disabled for REQUEST entries."
        }

        return (
            <div>
                <i style={{ cursor: canEdit ? "pointer" : "not-allowed" }} className={`${!canEdit ? 'disabled-icon' : 'cursor-pointer'} custom-edit-tooltip-${row.pettyCashId}`} onClick={canEdit ? () => handleEditPettyCash(row) : null}>
                    <img src={EditImg} style={{ height: 23 }} />
                </i>
                {
                    tooltipMessage && (
                        <Tooltip target={`.custom-edit-tooltip-${row.pettyCashId}`} position="top" autoHide>
                            {tooltipMessage}
                        </Tooltip>
                    )
                }
            </div>
        )
    }

    const handleRaiseTicket = (row) => {
        setSelectedRow(row)
        setIsRaiseTicketVisible(true)
    }

    const raiseIssueBody = (row) => {
        const {isPermitted} = checkPermissions({ ...usersData, permissions: [168] })
        const relatedPettyCashTickets = ticketsData.filter(eachTicket => eachTicket.docNo === row.docNo)

        let relatedTicket = null 
        if(relatedPettyCashTickets && relatedPettyCashTickets.length > 0){
            relatedTicket = relatedPettyCashTickets[0]
        }

        return (
            <div>
                {relatedTicket && relatedTicket.ticketId ? (
                    ([1,9,10].includes(relatedTicket.ticketStatusId)) ? (
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "grey" }} onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')} title={'In Progress'}>
                            <img src={WorkInProgressImg} style={{height: 23}}/>
                        </a>
                    ) :
                    relatedTicket && relatedTicket.ticketStatusId === 8 ? (
                        <a
                          style={{ cursor: "pointer", fontSize: "20px", color: "orange" }}
                          onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')}
                          title={'Pending Closure'}
                        > <img src={greyClockImg} style={{height: 24}}/></a>
                      ) : (
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "darkgreen" }} onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')} title={'Resolved'}>
                            <img src={checkInCircleImg} style={{height: 30}} />
                        </a>
                    )
                ) : (
                    <>
                        <i style={{ cursor: isPermitted? "pointer" : "not-allowed", fontSize: "20px", color: "red" }}
                            className={`${!isPermitted ? 'disabled-icon' : 'cursor-pointer'} custom-raise-tooltip-${row.pettyCashId}`}
                            onClick={isPermitted ? () => handleRaiseTicket(row) : null}
                        >
                            <img src={RaiseImg} style={{height: 26}}/>
                        </i>
                        {
                            !isPermitted && (
                                <Tooltip target={`.custom-raise-tooltip-${row.pettyCashId}`} position="top" autoHide>
                                    Access restricted: Only Finance team can raise issues.
                                </Tooltip>
                            )
                        }
                    </>
                )}
            </div>
        );
    }

    const getBookingStatusBody = (row) => {
        const relatedBookingLogs = bookingLogs.filter(eachBookingLog => eachBookingLog.docNo === row.docNo)
        const relatedBookingLog = _.maxBy(relatedBookingLogs, "bookingLogId")
        let relatedBookedBy = {}

        let bookingDate = ""
        if(relatedBookingLog){
            if(relatedBookingLog.bookedAt){
                bookingDate = moment(relatedBookingLog.bookedAt).format(DATE_FORMAT)
                relatedBookedBy = companyUsers.find(each => each.userId === relatedBookingLog?.bookedBy)
            }
            if(relatedBookingLog.unBookedAt){
                bookingDate = moment(relatedBookingLog.unBookedAt).format(DATE_FORMAT)
                relatedBookedBy = companyUsers.find(each => each.userId === relatedBookingLog?.unbookedBy)
            }
        }

        return(
            <div className='req-no-container ml-1' style={{position: "relative"}}>
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row["docTracker.bookedStatus"] ? 
                        <>
                            { relatedBookedBy ? <div className='doc-no'>{relatedBookedBy.firstName} {relatedBookedBy.lastName}</div> : null }
                        </>
                        : <div className='doc-no'>Not Booked</div>
                    }
                </div>
                <p className='date'>{bookingDate}</p>
            </div>
        )
    }

    const getStatusBody = (row) => {
        if (row.entryType === "REQUEST"){
            const relatedStatus = statusList?.find(eachStatus => eachStatus?.statusId === row["vendorPayment.statusId"])
            return(
                <div className='flex flex-row justify-content-center align-items-center'>
                    <p>{relatedStatus?.status ? relatedStatus?.status : "-"}</p>
                </div>
            )
        }else{
            const relatedStatus = statusList?.find(eachStatus => eachStatus?.statusId === row?.statusId)
            return(
                <div className='flex flex-row justify-content-center align-items-center'>
                    <p>{relatedStatus?.status ? relatedStatus?.status : "-"}</p>
                </div>
            )
        }
    }

    const getSecondayPaymentStatusBody = (row) => {
        const relatedPrimaryPettyCashAccount = pettyCashAccountsDetails.find(eachPettyCashAccount => eachPettyCashAccount.pettyCashAccountsId === pettyCashAccount?.pettyCashAccountId)
        const canEdit = relatedPrimaryPettyCashAccount?.userId === usersData.userId
        
        const handleSecondayPaymentEdit = (e) => {
            op.current.toggle(e)
            setSelectedPettyCashId(row.pettyCashId)
        }
        
        if (relatedPrimaryPettyCashAccount?.userId === row.createdBy){
            return(
                <div> - </div>
            )
        }

        return (
            <div className='flex flex-col justify-content-center align-items-center'>
                {row.secondaryPaymentStatus ? (
                    <>
                        <p style={{color: "green"}}> <b>PAID</b> <br /> <span style={{fontSize : "12px"}}> {moment(new Date(row.secondaryPaymentDate)).format(DATE_FORMAT)}</span> </p>
                    </>
                ) : (
                    <>
                        <p style={{color: "red"}}><b>UNPAID</b></p>
                        <i
                            style={{ fontSize: '0.9rem' }}
                            className={`pi pi-file-edit ml-1 ${!canEdit ? 'disabled-icon' : 'cursor-pointer'} custom-tooltip-${row.pettyCashId}`}
                            onClick={canEdit ? handleSecondayPaymentEdit : null}
                        ></i>
                        {
                            !canEdit && (
                                <Tooltip target={`.custom-tooltip-${row.pettyCashId}`} position="top" autoHide>
                                    Only the primary holder has access to edit.
                                </Tooltip>
                            )
                        }
                    </>
                )}
            </div>
        )
    }
    

    const getVendorPaymentBody = (row) => {
        const date = moment(row["vendorPayment.createdAt"]).format(DATE_TIME_FORMAT)
        return(
            <div className='req-no-container' style={{position: "relative"}}>
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row["vendorPayment.docNo"] ? 
                        <>
                            <p className="doc-no">{row["vendorPayment.docNo"]}</p>
                            <CopyToClipboard text={row["vendorPayment.docNo"]} />
                        </>
                        : "-"
                    }
                </div>
                {
                    row["vendorPayment.createdAt"] ? 
                    <p className='mr-4 date'>{date}</p> : ""
                }
            </div>
        )
    }

    const getPettyCashTypeBody = (row) => {
        return row.entryType
    }

    const getKAMBody = (row) => {
        const relatedPettyCashAccount = pettyCashAccountsDetails?.find(eachPettyCashAccount => eachPettyCashAccount?.pettyCashAccountsId === row?.pettyCashAccount)
        let kamName = getFullName(row["users.firstName"], row["users.lastName"])
        
        let relatedCompanyBranch = null
        if(relatedPettyCashAccount && relatedPettyCashAccount.pmBranchId){
            relatedCompanyBranch = usersData.PMCompanyDetails.companyBranches.find(eachBranch => eachBranch.branchId === relatedPettyCashAccount.pmBranchId)
        }

        if(kamName){
            return (
                <div>
                    <div><b>{relatedPettyCashAccount?.pettyCashAccount}</b></div>
                    <PMUserName userName={kamName} userId={row.createdBy}/><br />
                    {
                        relatedCompanyBranch ?
                        <span style={{ fontSize: '12px', color: 'gray' }}>
                                ({relatedCompanyBranch.branchName})
                        </span>
                        : "-"
                    }
                </div>
            )
        }
    }

    const getDocBody = (row) => {
        return (
            row.documentPath?.length > 0 && row.documentType !== "VOUCHER" ?
                <>
                    <Button label="View Docs" text className="small-btn" onClick={() => handleViewDocs(row.pettyCashId)}/>
                </> : 
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row.voucherNo ?
                        <>
                            <p className="doc-no" style={{cursor: 'pointer'}} onClick={() => window.open(`/voucher/${row?.pettyCashId}`)}>{row?.voucherNo}</p>
                            <CopyToClipboard text={row?.voucherNo} />
                        </> : "-"
                    }
                </div>
            
        )
    }

    const actionMenuItems = [
        {
            label: 'Book PettyCash',
            icon: '',    
            command : () => handleBookPettyCash(),
            permissions: [105]
        },
        {
            label: 'Unbook PettyCash',
            icon: '',
            command : () => handleUnBookPettyCash(),
            permissions: [105]
        },
        {
            label: 'Add Expense',
            icon: '',
            command: () => {
                handleAddExpenseActionClick()
            },
            permissions: [35]
        },
        {
            label: 'Request Petty Cash',
            icon: '',
            command: () => {
                handleRequestActionClick()
            }
        },
    ]

    const handleBookPettyCash = async () => {
        if (selectedPettyCash?.length > 0){
            setIsLoading(true)
            const relatedDocNos = selectedPettyCash?.map(eachPettyCash => eachPettyCash?.docNo)
            const bookingLogs = selectedPettyCash?.map(eachPettyCash => {
                return {
                    docNo : eachPettyCash?.docNo,
                    bookedBy : usersData?.userId,
                    bookedAt : new Date()
                }
            })
            const ticketsToBeClosed = []
            selectedPettyCash.map(eachPettyCash => {
                const isTicketExists = eachPettyCash["relatedTicket.ticketId"]
                if (isTicketExists){
                    let ticket = {
                        ticketId: eachPettyCash["relatedTicket.ticketId"],
                        docNo: eachPettyCash["relatedTicket.docNo"],
                        ticketStatusId: eachPettyCash["relatedTicket.ticketStatusId"]
                    }
                    ticketsToBeClosed.push(ticket)
                }
            })

            const data = {
                docNos: relatedDocNos,
                bookingStatus: true,
                updatedBy: usersData?.userId,
                updatedAt: new Date(),
                bookingLogs: bookingLogs,
                ticketsToBeClosed: ticketsToBeClosed
            }
            const response = await updatePettyCashBookingStatus(data)
            if (response?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Booking Status is not Updated', detail:response.data.error, life: 3000}))
            }else {

                dispatch(raiseToast({severity:'success', detail: 'Booking Status Updated Successfully', life: 3000}))
                setSelectedPettyCash([])
                dispatch(fetchPettyCash({ ...paginationParams, ...searchParams }))
            }
            setIsLoading(false)
        }else {
            dispatch(raiseToast({severity:'error', detail: 'Please Select the Petty Cashes', life: 3000}))
        }
    }


    const handleUnBookPettyCash = async () => {
        if (selectedPettyCash?.length > 0){
            setIsLoading(true)
            const relatedDocNos = selectedPettyCash?.map(eachPettyCash => eachPettyCash?.docNo)
            const bookingLogs = selectedPettyCash?.map(eachPettyCash => {
                return {
                    docNo : eachPettyCash?.docNo,
                    unbookedBy : usersData?.userId,
                    unbookedAt : new Date()
                }
            })
            const data = {
                docNos : relatedDocNos,
                bookingStatus : false,
                updatedBy : usersData?.userId,
                updatedAt: new Date(),
                bookingLogs : bookingLogs
            }
            const response = await updatePettyCashBookingStatus(data)
            if (response?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Booking Status is not Updated', detail:response.data.error, life: 3000}))
            }else {
                dispatch(raiseToast({severity:'success', detail: 'Booking Status Updated Successfully', life: 3000}))
                setSelectedPettyCash([])
                dispatch(fetchPettyCash({ ...paginationParams, ...searchParams }))
            }
            setIsLoading(false)
        }else {
            dispatch(raiseToast({severity:'error', detail: 'Please Select the Petty Cashes', life: 3000}))
        }
    }


    const handleViewDocs = async (pettyCashId) => {
        const relatedPettyCash = pettyCashData?.find(eachPettyCash => eachPettyCash?.pettyCashId === pettyCashId)
    
        if (relatedPettyCash?.documentPath?.length === 1) {
            setSelectedPettyCashDoc(relatedPettyCash)
            setVisibleDocViewer(true)
        } else {
            setSelectedPettyCashDoc(relatedPettyCash)
            setVisiblePettyCashDocs(true)
        }
    }

    const handleAddExpenseActionClick = async () => {
        if (pettyCashAccount?.pettyCashAccountId){
            setVisibleAddExpense(true)
        }else{
            dispatch(raiseToast({severity:'error', summary: 'Petty Cash User', detail: "Please Contact the tech team offline for creating pettycash account", life: 3000}))   
        }
    }

    const handleRequestActionClick = async () => {
        let relatedPrimaryPettyCashAccount = {}
        if (pettyCashAccount){
            relatedPrimaryPettyCashAccount = pettyCashAccountsDetails.find(eachPettyCashAccount => eachPettyCashAccount.pettyCashAccountsId === pettyCashAccount.pettyCashAccountId)
        }

        if (pettyCashAccount?.pettyCashAccountId && relatedPrimaryPettyCashAccount.userId === usersData.userId){
            setVisiblePettyCashRequest(true)
        }else if (relatedPrimaryPettyCashAccount.pettyCashAccountsId && relatedPrimaryPettyCashAccount.userId !== usersData.userId){
            dispatch(raiseToast({severity:'error', detail: "Only Primary Account Holder can raise the Request.", life: 3000}))
        }else{
            dispatch(raiseToast({severity:'error', summary: 'Petty Cash User', detail: "Please Contact the tech team offline for creating pettycash account", life: 3000}))   
        }
    }

    const getTransactionDateBody = (row) => {
        return (
            <div className='flex flex-row justify-content-center align-items-center'>
                <p className="mt-0">{row?.transactionDate ? getDateString(row?.transactionDate) : "-"}</p>
            </div>
        )
    }

    const getAmountAndTransactionDateBody = (row) =>{
        return(
            <>
                <div>{getAmountBody(row)}</div>
                <div>{getTransactionDateBody(row)}</div>
            </>
        )
    }

    const getPettyCashTypeAndExpenseBody = (row) =>{
        return(
            <div>
                <div className="font-semibold text-xs">{getPettyCashTypeBody(row)}</div>
                <div className="text-xs">{getNatureOfExpenseBody(row)}</div>
            </div>
        )
    }

    const tableColumns = [
        {
            header: getHeaderCheckbox, body: (row) => getBodyCheckbox(row)
        },
        {
            header: 'PettyCash No.', field: 'docNo' , body: getTxnNoBody, style: {marginLeft: "1", minWidth:"120px"}
        },
        {
            header: 'Vendor Payment No.', field: '' , body: getVendorPaymentBody, style: { minWidth:"140px"}
        },
        // {
        //     header: 'Transaction Date', field: '' , body: getTransactionDateBody, style: { minWidth:"100px"}
        // },
        {
            header: 'KAM', field: '', body: getKAMBody, style: {minWidth: "150px"}
        },
        // {
        //     header : 'Petty Cash Type', field : 'entryType', body: getPettyCashTypeBody, style: { minWidth:"130px"}
        // },
        {
            header : 'PettyCash Type & Nature Of Exp.', field : 'entryType', body: getPettyCashTypeAndExpenseBody, style: { minWidth:"180px"}
        },
        // {
        //     header: 'Amount', field: 'amount', body: getAmountBody, style: {minWidth: "80px"}
        // },
        {
            header: 'Amt & Trans. Date', field: '', body: getAmountAndTransactionDateBody, style: {minWidth: "150px"}
        },
        // {
        //     header: 'Nature Of Expense', field: 'natureOfExpense', body: getNatureOfExpenseBody, style: { minWidth:"190px"}
        // },
        {
            header: 'Description', field: 'description',  body: getDescriptionBody
        },
        {
            header: 'Documents', field: '', style: {width: "180px"},body: getDocBody
        },
        {
            header: 'Seconday Payment', field: '', style: {width: "250px"}, body : getSecondayPaymentStatusBody
        },
        {
            header: 'Status', field: '', body : getStatusBody, style: {minWidth: "80px"}
        },
        {
            header: 'Booking Status', field: '', body: getBookingStatusBody, style: {minWidth: "120px"}
        },
        {
            header: 'Raise Issue', field: '', body: raiseIssueBody, style: {minWidth: "30px"}
        },
        {
            header: 'Edit', field: '', body: editPettyCash, style: {minWidth: "30px"}
        }
    ]

    let relatedAccount = null
    if (searchParams?.account){
        relatedAccount = pettyCashAccountsDetails?.find(eachPettyCashAccount => eachPettyCashAccount?.pettyCashAccountsId === searchParams?.account)
    }else{
        relatedAccount = pettyCashAccountsDetails?.find(eachPettyCashAccount => eachPettyCashAccount?.pettyCashAccountsId === searchParams?.pettyCashAccount)
    }

    let relatedPrimaryUser = null

    let relatedPettyCashUsers = []

    if(relatedAccount){
        relatedPrimaryUser = companyUsers.find(eachCompanyUser => eachCompanyUser.userId === relatedAccount.userId)

        const relatedPettyCashAccountUsers = pettyCashUsers.filter(eachUser => eachUser.pettyCashAccountId === relatedAccount.pettyCashAccountsId)
        const relatedUserIds = relatedPettyCashAccountUsers.map(eachUser => eachUser.userId)
        relatedPettyCashUsers = companyUsers.filter(eachCompanyUser => relatedUserIds.includes(eachCompanyUser.userId) && eachCompanyUser.userId !== relatedPrimaryUser.userId) // To exclude primary user from pettycash user list)
        relatedPettyCashUsers = sortArrayOfObjectsInAlphabeticalOrder(relatedPettyCashUsers, "firstName")

    }

    let pettyCashOpeningBalance = openingBalance
    let pettyCashClosingBalance = closingBalance

    if (searchParams?.fromDate && Date.parse(searchParams?.fromDate) <= Date.parse(new Date("02-03-2024"))){
        pettyCashOpeningBalance = 'NA'
    }
    
    if (searchParams?.toDate &&  moment(searchParams?.toDate).format("YYYY-MM-DD") >  moment(new Date()).format("YYYY-MM-DD")){
        pettyCashClosingBalance = 'NA'
    }
    
    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
        {
            icon: isSearchPinned ? "pi pi-lock" : "pi pi-lock-open",
            command: () => toggleSearchPin() 
        }
    ]

    let displaySearchBox = isSearchPinned || isHoveringSearchZone || isSearchVisible

    return (
        <div className="petty-cash-layout flex flex-column">
            <div
                onMouseEnter={() => {
                    if (!isSearchPinned) {
                        setIsHoveringSearchZone(true)
                        setHasEverHoveredRightEdge(true)
                        dispatch(setIsSearchVisible(true))
                    }
                }}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '8px',
                    height: '100vh',
                    zIndex: 999
                }}
            />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">PETTY CASH</h4> 
                <div className="flex flex-column md:flex-row gap-2 justify-content-end mb-2">
                    {
                        openingBalance || closingBalance ? 
                        <>
                            <div className=" flex justify-content-space-between">
                                <div className={`mt-2 mr-4 custom-account-tooltip-${relatedAccount?.pettyCashAccountsId}`}>Account : <span className="approved-balance">{relatedAccount?.pettyCashAccount && relatedAccount?.pettyCashAccount}</span></div>
                                <div className="mt-2 mr-4">Opening Bal : <span style={{ color: pettyCashOpeningBalance < 0 ? 'red' : '#0bbaaa' }} className="approved-balance">{numberConversion(pettyCashOpeningBalance, numberLocale)}</span>{pettyCashAccount?.pettyCashAccountId && <span>{` (${getDateString(searchParams?.fromDate ? searchParams?.fromDate : new Date())})`}</span>}</div>
                                <div className="mt-2">Closing Bal : <span style={{ color: pettyCashClosingBalance < 0 ? 'red' : '#0bbaaa' }} className="approved-balance">{numberConversion(pettyCashClosingBalance, numberLocale)}</span>{pettyCashAccount?.pettyCashAccountId && <span>{` (${getDateString(searchParams?.toDate ? searchParams?.toDate : new Date())})`}</span>}</div>
                            </div>
                            <Tooltip target={`.custom-account-tooltip-${relatedAccount?.pettyCashAccountsId}`} position="top" autoHide>
                                <div>
                                    <div className="mb-1">
                                        <b>Primary User:</b>{' '}
                                        {relatedPrimaryUser
                                            ? getFullName(relatedPrimaryUser.firstName, relatedPrimaryUser.lastName)
                                            : 'Not found'}
                                    </div>
                                    {relatedPettyCashUsers
                                        .filter(eachUser => eachUser.userId !== relatedPrimaryUser.userId)
                                        .length > 0 && (
                                            <div>
                                                <b>Secondary Users:</b>
                                                <ul style={{ margin: 0, paddingLeft: '16px' }}>
                                                    {relatedPettyCashUsers.map(eachUser => (
                                                            <li key={eachUser.userId}>
                                                                {getFullName(eachUser.firstName, eachUser.lastName)}
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                    )}
                                </div>
                            </Tooltip>
                        </>
                        : 
                        <div className="mt-2 mr-4">Balance : <span style={{ color: pettyCashBalance?.approvedBalance < 0 ? 'red' : '#0bbaaa' }}  className="approved-balance">{pettyCashBalance?.approvedBalance ? numberConversion(round(pettyCashBalance?.approvedBalance), numberLocale) : 0}</span>{pettyCashAccount?.pettyCashAccountId && <span>{` (${getDateString(pettyCashBalance?.balanceDate)})`}</span>}</div>
                    }
                    <div className='req-action-Body flex justify-content-end'>
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        {/* <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                        <Button icon="pi pi-filter" className={`h-2rem ml-2  p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                        <ButtonGroup buttons={actionButtons} />
                    </div>
                </div>
            </div>
            <Loading visible={isLoading} />
            <div className='flex flex-row'>
                <div className="petty-cash-table" style={{ order: "1", width: displaySearchBox && !isMobileDevice ? "82%" : "100%" , maxHeight: "'calc(100%-100px)'"}}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1" >
                            <Table 
                                lazy 
                                page={paginationParams.pageNo} 
                                onPageChange={(e)=> handlePageChange(e)} 
                                totalRecords={paginationParams.totalRecords} 
                                tableColumns={tableColumns} 
                                data={pettyCashData} 
                                rows={paginationParams.recordsPerPage} 
                                scrollable={"true"}
                                scrollHeight="550px" 
                                paginator
                                excessPagesFound= {paginationParams.excessPagesFound}
                                loading={isTableLoading}  
                            />
                        </div>
                    </div>
                </div>

                {displaySearchBox && !isMobileDevice && (
                    <div
                        style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end"
                        onMouseLeave={(e) => {
                            const bounds = e.currentTarget.getBoundingClientRect()
                            const leftExit = e.clientX < bounds.left
                            const topExit = e.clientY < bounds.top
                            const bottomExit = e.clientY > bounds.bottom

                            if (!isSearchPinned && (leftExit || topExit || bottomExit)) {
                                setIsHoveringSearchZone(false)
                                setHasEverHoveredRightEdge(false)
                            }
                        }}

                        onMouseEnter={() => {
                            if (!isSearchPinned) {
                                setIsHoveringSearchZone(true)
                            }
                        }}
                    >
                        <Search pettyCashAccount={pettyCashAccount} pettyCashAccountsDetails={pettyCashAccountsDetails} pettyCashUsers={pettyCashUsers} getOpeningAndClosingBalances={getOpeningAndClosingBalances} setOpeningBalance={setOpeningBalance} setClosingBalance={setClosingBalance}/>
                    </div>
                )}

                {/* {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Search pettyCashAccount={pettyCashAccount} pettyCashAccountsDetails={pettyCashAccountsDetails} pettyCashUsers={pettyCashUsers} getOpeningAndClosingBalances={getOpeningAndClosingBalances} setOpeningBalance={setOpeningBalance} setClosingBalance={setClosingBalance}/>
                    </div>
                } */}

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <Search pettyCashAccount={pettyCashAccount} pettyCashAccountsDetails={pettyCashAccountsDetails} pettyCashUsers={pettyCashUsers} getOpeningAndClosingBalances={getOpeningAndClosingBalances} setOpeningBalance={setOpeningBalance} setClosingBalance={setClosingBalance}/>
                        </Sidebar>          
                    </div>
                }
            </div>

            <Dialog header="Petty Cash Request" visible={visiblePettyCashRequest} style={{ width: '35vw', height: '30vh' }} onHide={() => setVisiblePettyCashRequest(false)}>
                <RequestPettyCash pettyCashAccount={pettyCashAccount} getPettyCashData={getPettyCashData} setVisiblePettyCashRequest={setVisiblePettyCashRequest} pettyCashBalance={pettyCashBalance}/>
            </Dialog>

            <Dialog header="Add Expense" className="add-expense-dialog" headerStyle={{ paddingBottom: "10px", paddingTop: "10px" }} contentStyle={{ backgroundColor: "#f8f9fa" }} visible={visibleAddExpense} style={{ width: '80vw', backgroundColor: "#eeeff0" }} onHide={() => setVisibleAddExpense(false)}>
                <AddExpense pettyCashAccount={pettyCashAccount} getPettyCashData={getPettyCashData} setVisibleAddExpense={setVisibleAddExpense} productsList={productsList} setProductsList={setProductsList} transactionDetails={transactionDetails} setTransactionDetails={setTransactionDetails}/>
            </Dialog>

            <Dialog header="Pending Request" className="add-expense-dialog" headerStyle={{ paddingBottom: "10px", paddingTop: "10px" }} contentStyle={{ backgroundColor: "#f8f9fa" }} visible={visiblePendingRequest} style={{ width: '80vw', backgroundColor: "#eeeff0" }} onHide={() => setVisiblePendingRequest(false)}>
                <PendingRequest pettyCash={pendingPettyCash}/>
            </Dialog>
            {
                visibleDocViewer &&
                <FileViewModal
                    visible={visibleDocViewer}
                    document={selectedPettyCashDoc?.documentPath?.[0]}
                    handleOnHide={handleDocViewOnHide}
                />
            }
            <Dialog header={`Petty Cash Documents for Doc No: ${selectedPettyCashDoc?.docNo}`} className="add-expense-dialog" headerStyle={{ paddingBottom: "10px", paddingTop: "10px" }} contentStyle={{ backgroundColor: "#f8f9fa" }} visible={visiblePettyCashDocs} style={{ width: '35vw', backgroundColor: "#eeeff0" }} onHide={() => {setVisiblePettyCashDocs(false); setSelectedPettyCashDoc([])}}>
                {
                    selectedPettyCashDoc?.documentPath?.map((eachDoc, index) => {
                        return (
                            <li className="vendor-details-li flex flex-wrap" key={eachDoc}>
                                <a className="view-btn mr-3">{`${index+1})`}</a>
                                <FileViewAndRemove doc={{url: eachDoc}} />
                            </li>
                        )
                    })
                }
            </Dialog>
            <OverlayPanel ref={op} style={{ width: '246px', minHeight: "8px" }} dismissable>
                <h4 className="mt-3 ml-2 mb-2" >SECONDARY PAYMENT</h4>
                <SecondayPaymentStatus
                    selectedPettyCashId={selectedPettyCashId}
                />
            </OverlayPanel>
            <Dialog header="RAISE TICKET" visible={isRaiseTicketVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => {setIsRaiseTicketVisible(false)}}>
                <div style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                    <RaiseTicketModal selectedRow={selectedRow} setIsLoading={setIsLoading} setIsRaiseTicketVisible={setIsRaiseTicketVisible}/>
                </div>
            </Dialog>
            <Dialog header="EDIT PRODUCTS" visible={isEditPettyCashVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => {setIsEditPettyCashVisible(false)}}>
                <div style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                    <EditPettyCash selectedRow={selectedRow} pettyCashItemsData={pettyCashItemsData} setIsLoading={setIsLoading} setIsEditPettyCashVisible={setIsEditPettyCashVisible} pettyCashAccountsDetails={pettyCashAccountsDetails} onDeleteClick={onDeleteClick}/>
                </div>
            </Dialog>
        </div>
    )
}

export default PettyCash